module.exports = __webpack_public_path__ + "static/media/edit.b1ff3fcf.svg";